import { useCallback, useEffect, useState } from "react"
import { useLocation } from "react-router"
import { Transition } from "history"

import { useAppDispatch, useAppSelector } from "../core/app/hooks"
import {
  setIsbrowserBack,
  setIsRouteChangeBlocked,
} from "../core/app/slices/navigationPopup/navigationPopupSlice"
import { RootState } from "../core/app/store"

import { useBlocker } from "./useBlocker"
import { useMyNavigation } from "./useMyNavigation"
import { safeCloseWindow } from "@/core/app/CloseTabContext"

export const useCallbackPrompt = (when: boolean) => {
  const navigate = useMyNavigation()
  const location = useLocation()
  const [showPrompt, setShowPrompt] = useState<boolean>(false)
  const [lastLocation, setLastLocation] = useState<any>(null)
  const [confirmedNavigation, setConfirmedNavigation] = useState(false)
  const dispatch = useAppDispatch()

  const cancelNavigation : ()=>void = useCallback(() => {
    setShowPrompt(false)
    dispatch(setIsbrowserBack(false))
    setLastLocation(null)
  }, [])

  const { isRouteChangeBlocked, isbrowserBack } = useAppSelector(
    (state: RootState) => state.navigationPopup,
  )
  const {shouldCloseTab } = useAppSelector(
    (state: RootState) => state.udTreatService,
  )

  // handle blocking when user click on another route prompt will be shown
  const handleBlockedNavigation = useCallback(
    (nextLocation: Transition) => {
      // in if condition we are checking next location and current location are equals or not
      if (
        !confirmedNavigation &&
        nextLocation.location.pathname !== location.pathname
      ) {
        setShowPrompt(true)
        setLastLocation(nextLocation)
        return false
      }
      return true
    },
    [confirmedNavigation, location],
  )

  const confirmNavigation : ()=>void = useCallback(() => {
    setShowPrompt(false)
    setConfirmedNavigation(true)
    dispatch(setIsRouteChangeBlocked({ isRouteChangeBlocked: false }))
  }, [])

  useEffect(() => {
    if (confirmedNavigation) {
      if(shouldCloseTab){
        safeCloseWindow()
        return
      }
      if (isbrowserBack) {
        navigate(-1)
        dispatch(setIsbrowserBack(false))
      } else if (lastLocation) {
        navigate(lastLocation.location?.pathname + lastLocation.location?.search)
      }
      setConfirmedNavigation(false)
    }
  }, [confirmedNavigation, lastLocation])

  useBlocker(handleBlockedNavigation, when)

  return [showPrompt, confirmNavigation, cancelNavigation] as  [boolean, ()=>void, ()=>void]
}
